"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
var _dialog = _interopRequireDefault(require("@/mixins/dialog"));
var _timeConflit = _interopRequireDefault(require("../mixins/timeConflit"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** services */
/** mixins */
/** statics */
var _default2 = exports.default = {
  components: {},
  mixins: [_dialog.default, _timeConflit.default],
  props: {
    // 左侧table选中的date具体信息
    actDateinfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 其他计划类型
    planTypeOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 所有下拉options配置
    /**
     * optConfig.visitPurposeOptions: [], // 拜访目的select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var defaultForm = {
      planTaskTargetDate: ''
    };
    return {
      actualPlanTaskFlag: '',
      // Y:实际任务；N:计划任务
      formLabelWidth: '120px',
      // isShowModel: false, // from mixins
      dialogStatus: 'create',
      /** form group */
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var now = new Date();
          var dayOfWeek = now.getDay(); // Sunday is 0, Monday is 1, ..., Saturday is 6
          var daysUntilNextMonday = dayOfWeek === 0 ? 1 : 7 - dayOfWeek;
          var minDate = new Date(now);
          minDate.setDate(minDate.getDate() + daysUntilNextMonday);
          var maxDate = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate() + 14);
          return time > maxDate || time < minDate;
        }
      },
      form: Object.assign({}, defaultForm),
      initForm: Object.assign({}, defaultForm),
      rules: {
        validateIpt: [{
          required: true,
          trigger: ['blur'],
          message: this.$t('errorValid.empty')
        }],
        validateChoose: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptySelect')
        }]
      },
      /** other */
      canSubmit: true
    };
  },
  computed: {
    // 弹窗标题
    dialogTitle: function dialogTitle() {
      return "".concat(this.$t('doubleWeekPlan.title.editDate'), "\uFF1A").concat(this.actDateinfo.planTaskDateStr || '');
    }
  },
  methods: {
    // open dialog init
    init: function init(type) {
      // 没有选中日期不能操作
      if (!this.actDateinfo.planTaskDate) {
        return false;
      }
      this.isShowModel = true;
    },
    /** save event */saveItem: function saveItem() {
      var _this = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        // 重复触发
        if (!_this.canSubmit) {
          return false;
        }
        _this.canSubmit = false;
        var params = {
          planTaskDate: _this.actDateinfo.planTaskDate || '',
          planTaskTargetDate: _this.form.planTaskTargetDate.replaceAll('-', '')
        };
        (0, _doubleWeekPlan.changePlanTaskDate)(params).then(function () {
          _this.$message({
            message: _this.$t('common.saveSuccess'),
            type: 'success'
          });
          _this.$emit('refresh');
          _this.isShowModel = false;
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          _this.canSubmit = true;
        });
      });
    }
  }
};